<template>
    <div>
        <portal to="modals" v-if="hasError">
            <modal @close="deleteError">
                <template slot="header">Error</template>

                <div v-show="is401">
                    Please Login to edit data.

                    <a href="/en/login">Login</a>
                </div>

                <div v-show="isUnknown">
                    <h1>{{ error }}</h1>
                    An error occured.

                    {{ error }}
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
    export default {
        name: "ErrorResponse",

        computed: {
            hasError() {
                return this.$store.state.error !== null;
            },
            error() {
                return this.$store.state.error.response;
            },
            status() {
                return _.get(this.error, 'status', 0);
            },
            is401() {
                return this.status === 401;
            },
            isUnknown() {
                return ![401].includes(this.status);
            }
        },

        methods: {
            deleteError() {
                this.$store.state.error = null;
            },
        },
    }
</script>

<style scoped>

</style>
